export default __webpack_public_path__ + "static/media/chi6.51220eca.jpg";